module.exports = __webpack_public_path__ + "media/images/games/clash-royale/connect-377e4df1a8aa109d2a24bdf17ccbe267.png";